<template>
    <div>

        <rkm-area
            title="Transferências enviadas"
            no-margin-top
        >

            <rkm-table
                :fields="fields.tables.tipo"
                :items="dados"
                :filter="filter"
                ref="Table"
                class="mt-3"
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(cota)="row">
                    <span>{{ getCotaExame(row.item.exames) }}</span>
                </template>

                <template v-slot:cell(origemInicio)="row">
                    <span>{{ row.item.origemInicio }} - {{ row.item.origemFim }}</span>
                </template>

                <template v-slot:cell(destinoInicio)="row">
                    <span>{{ row.item.destinoInicio }} - {{ row.item.destinoFim }}</span>
                </template>

            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Transferências recebidas"
        >

            <rkm-table
                :fields="fields.tables.transferencia"
                :items="dadosRecebidos"
                :filter="filter"
                ref="Table"
                class="mt-3"
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(origemUnidadeId)="row">
                    <span>{{ getNomeOrigem(row.item.origemUnidadeId) }}</span>
                </template>

                <template v-slot:cell(origemInfraestruturaId)="row">
                    <span>{{ getInfraestruturaOrigem(row.item.origemUnidadeId, row.item.origemInfraestruturaId) }}</span>
                </template>

                <template v-slot:cell(cota)="row" >
                    <span>{{ getCotaExame(row.item.exames) }}</span>
                </template>

                <template v-slot:cell(origemInicio)="row">
                    <span>{{ row.item.origemInicio }} - {{ row.item.origemFim }}</span>
                </template>

                <template v-slot:cell(destinoInicio)="row">
                    <span>{{ row.item.destinoInicio }} - {{ row.item.destinoFim }}</span>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        {
                            key: 'destinoNomeFantasia',
                            label: 'Unidade destino',
                            sortable: true
                        },
                        {
                            key: 'destinoInfraestruturaNome',
                            label: 'Local de atendimento',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                    ],
                    transferencia: [
                        {
                            key: 'origemUnidadeId',
                            label: 'Unidade origem',
                            sortable: true
                        },
                        {
                            key: 'origemInfraestruturaId',
                            label: 'Local de atendimento',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                    ],
                }
            }
        },
        dados(){

            let cota = this.cotaUnidadeSolicitante.filter(i => {return i.origemCotaTipoId == this.cotaTipoId
                && moment(
                    this.getFormatedDate(this.cota.periodo.start, 'YYYY-MM-DD')
                )
                .isBetween(
                    i.origemInicio.split("/").reverse().join("-"),
                    i.origemFim.split("/").reverse().join("-"),
                    null,
                    '[]'
                )

                || i.origemCotaTipoId == this.cotaTipoId
                    && moment(
                        this.getFormatedDate(this.cota.periodo.end, 'YYYY-MM-DD')
                    )
                    .isBetween(
                        i.origemInicio.split("/").reverse().join("-"),
                        i.origemFim.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
            })

            let cotaOrigem = []

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                cota.forEach(a => {

                    if (a.exames.find(u => u.exameId === this.item.exameId && u.transferido != '0,00')) {
                        cotaOrigem.push(a)
                    }
                })
            } else {

                cota.forEach(a => {

                    if (a.exames.find(u => u.exameId === this.item.exameId && u.transferido > 0)) {
                        cotaOrigem.push(a)
                    }
                })
            }

            return cotaOrigem
        },
        dadosRecebidos(){

            let transferenciaLaboratorio = this.data.model.cotasTransferencia.filter(field =>
                field.unidadeTipoId == this.enums.tipoUnidade.LABORATORIO)

                if (transferenciaLaboratorio.length > 0) {

                    transferenciaLaboratorio = transferenciaLaboratorio.map(field2 => field2.destino)

                    Object.keys(transferenciaLaboratorio).forEach(a => {

                        let recebidos = transferenciaLaboratorio[a]
                            .filter(i => i.destinoUnidadeId == this.unidadeId
                                && i.destinoInfraestruturaId == this.infraestruturaId
                                && i.origemCotaTipoId == this.cotaTipoId
                                && moment(
                                    this.getFormatedDate(this.cota.periodo.start, 'YYYY-MM-DD')
                                )
                                .isBetween(
                                    i.destinoInicio.split("/").reverse().join("-"),
                                    i.destinoFim.split("/").reverse().join("-"),
                                    null,
                                    '[]'
                                )

                                || i.destinoUnidadeId == this.unidadeId
                                    && i.destinoInfraestruturaId == this.infraestruturaId
                                    && i.origemCotaTipoId == this.cotaTipoId
                                    && moment(
                                        this.getFormatedDate(this.cota.periodo.end, 'YYYY-MM-DD')
                                    )
                                    .isBetween(
                                        i.destinoInicio.split("/").reverse().join("-"),
                                        i.destinoFim.split("/").reverse().join("-"),
                                        null,
                                        '[]'
                                    )
                            )

                        recebidos.forEach(v => {

                            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (v.exames.find(u => u.exameId === this.item.exameId && u.transferido != '0,00')) {

                                    this.recebidos.push(v)
                                }
                            } else {

                                if (v.exames.find(u => u.exameId === this.item.exameId && u.transferido > 0)) {

                                    this.recebidos.push(v)
                                }
                            }
                        })
                    })
                }

            return this.recebidos
        },
    },
    data: () => ({
        items: [],
        recebidos: [],
        filter: null,
        enums: {
            tipoCota,
            tipoUnidade,
        },
    }),
    methods: {
        handleClearFilter() {
            this.filter = null
        },
        getCotaExame(item) {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let valor = item.find(u => u.exameId === this.item.exameId).transferido
                return this.formatMoney(valor, 2)
            } else {

                let quantidade = item.find(u => u.exameId === this.item.exameId).transferido
                return this.formatMoney(quantidade, 0)
            }
        },
        getNomeOrigem(unidadeId){

            const unidade = this.data.form.unidades.find(u => u.id == unidadeId)

            return unidade.nomeFantasia
        },
        getInfraestruturaOrigem(unidadeId, infraestruturaId){

            const unidade = this.data.form.unidades.find(u => u.id == unidadeId)
            const infraestrutura = unidade.infraestruturas.find(u => u.id == infraestruturaId)

            return infraestrutura.nome
        }
    },
    mixins: [data, formats],
    props: {
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        laboratorioUnidadeId: { type: Number, default: null },
        laboratorioInfraestruturaId: { type: Number, default: null },
        data: { type: Object, required: true },
        cotaUnidadeSolicitante: { type: Array, required: true },
        cota: { type: Object, required: true },
        item: { type: Object, required: true },
        cotaTipoId: { type: Number, required: true },
    },
}
</script>

<style scoped>
.colorButton {
    color: #fff;
}
</style>